import { Injectable, NgZone } from '@angular/core';
import { AnalyticsService } from 'src/smoothr-web-app-core/services/analytics/analytics.service';
import { TracifyService } from './tracify.service';

@Injectable({
	providedIn: 'root',
})
export class CookieConsentService {
	constructor(
		private ngZone: NgZone,
		private analyticsService: AnalyticsService,
		private tracifyService: TracifyService
	) {}
	public initializeCookieConsent() {
		window.addEventListener('CookieConsent', () => {
			this.ngZone.run(() => this.handleConsent());
		});
		window.addEventListener('CookieConsent.onConsentChanged', () => {
			this.ngZone.run(() => this.handleConsent());
		});
		window.addEventListener('load', () => {
			if (window['CookieConsent'] && window['CookieConsent'].consent) {
				this.ngZone.run(() => this.handleConsent());
			}
		});
	}

	private async handleConsent() {
		const consent = window['CookieConsent'].consent;
		if (consent) {
			if (consent.statistics) {
				await this.setAnalyticsEnabled(true);
			} else {
				await this.setAnalyticsEnabled(false);
			}
			if (consent.marketing) {
				this.enableMarketing();
			} else {
				this.disableMarketing();
			}
		}
	}
	private enableMarketing() {
		this.startBrazeInitialize();
		this.initializeTracify();
	}

	private disableMarketing() {}
	private startBrazeInitialize() {}

	private async initializeTracify() {
		try {
			await this.tracifyService.initializeTracifyScript();
			this.tracifyService.setupPageViewTracking();
			// Track initial page view after initialization
			setTimeout(() => {
				this.tracifyService.trackPageView();
			}, 1000);
		} catch (error) {
			console.warn('Failed to initialize Tracify:', error);
		}
	}
	async setAnalyticsEnabled(enabled: boolean) {
		await this.analyticsService.setAnalyticsCollectionEnabled(enabled);
	}
}
